let audio;
let primed = false;

const getAudio = () => {
  if (!audio) {
    audio = new Audio("/sound-logo.mp3");
    audio.preload = "auto";
  }
  return audio;
};

// Browsers block audio until first user gesture — prime on first interaction.
export const primeSoundLogo = () => {
  if (primed) return;
  primed = true;
  const a = getAudio();
  a.volume = 0;
  a.play()
    .then(() => {
      a.pause();
      a.currentTime = 0;
      a.volume = 0.7;
    })
    .catch(() => {});
};

export const playSoundLogo = (volume = 0.7) => {
  const a = getAudio();
  a.volume = volume;
  a.currentTime = 0;
  a.play().catch(() => {
    // Browser blocked it (no gesture yet) — replay on the visitor's next tap.
    window.addEventListener(
      "pointerdown",
      () => {
        const b = getAudio();
        b.volume = volume;
        b.currentTime = 0;
        b.play().catch(() => {});
      },
      { once: true }
    );
  });
};

let thruster;
export const playThruster = (volume = 0.5) => {
  if (!thruster) {
    thruster = new Audio("/thruster.mp3");
    thruster.preload = "auto";
  }
  thruster.volume = volume;
  thruster.currentTime = 0;
  thruster.play().catch(() => {});
};
